import React from 'react';

const Spinner = () => {
    return(
        <div className="">
            <div className="spinner"></div>
            <div className="backdrop"></div>
        </div>
    )
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/index.jsx